import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const DefaultError: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100" data-testid="default-error-page">
      <div className="text-center p-8 bg-white rounded-lg shadow-md" data-testid="default-error-content">
        <h1 className="text-4xl font-bold text-red-600 mb-4" data-testid="default-error-title">{t('error.oops')}</h1>
        <p className="text-xl text-gray-700 mb-6" data-testid="default-error-message">{t('error.somethingWentWrong')}</p>
        <Link
          to="/"
          className="inline-block px-6 py-3 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
          data-testid="default-error-home-link"
        >
          {t('common.backToHome')}
        </Link>
      </div>
    </div>
  );
};

export default DefaultError;
